import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPlanetComponent } from './simple-icons-planet.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPlanetComponent ],
    exports:      [ SimpleIconsPlanetComponent ],
    bootstrap:    []
})
export class SimpleIconsPlanetModule {}
